import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  timeout: 120000,
});

export const fetchSchema = async () => {
  const { data } = await apiClient.get("/schema");
  return data;
};

export const parseExcel = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await apiClient.post("/parse-excel", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const parseXbrl = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await apiClient.post("/parse-xbrl", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const parseFile = async (file) => {
  const name = (file.name || "").toLowerCase();
  if (name.endsWith(".xbrl") || name.endsWith(".xml")) {
    return { kind: "xbrl", ...(await parseXbrl(file)) };
  }
  return { kind: "excel", ...(await parseExcel(file)) };
};

export const classifyItems = async (items, lang = "it") => {
  const { data } = await apiClient.post("/classify", { items, lang });
  return data.items;
};

export const reclassify = async (items, lang = "it", sector = "generico", priorItems = null, priorYears = null, periodMonths = 12) => {
  const payload = { items, lang, sector, period_months: periodMonths };
  if (priorItems && priorItems.length) payload.prior_items = priorItems;
  if (priorYears && priorYears.length) payload.prior_years = priorYears;
  const { data } = await apiClient.post("/reclassify", payload);
  return data;
};

export const exportFile = async (kind, reclassified, ratios, lang, cover = null, advisorText = null, correctives = null, roadmap = null) => {
  const payload = { reclassified, ratios, lang };
  if (cover) payload.cover = cover;
  if (advisorText && kind === "pdf") payload.advisor_text = advisorText;
  if (correctives && kind === "pdf") payload.correctives = correctives;
  if (roadmap && kind === "pdf") payload.roadmap = roadmap;
  const res = await apiClient.post(`/export/${kind}`, payload, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  const ext = kind === "excel" ? "xlsx" : "pdf";
  a.download = `bilancio_riclassificato.${ext}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const generateAdvisor = async (reclassified, ratios, lang = "it", sector = null) => {
  const { data } = await apiClient.post("/advisor", { reclassified, ratios, lang, sector }, { timeout: 180000 });
  return data;
};

export const getCorrectives = async (reclassified, ratios, sector = "generico", lang = "it") => {
  const { data } = await apiClient.post("/correctives", { reclassified, ratios, sector, lang });
  return data;
};

export const getCorrectivesAI = async (reclassified, ratios, sector = "generico", lang = "it") => {
  const { data } = await apiClient.post("/correctives/ai", { reclassified, ratios, sector, lang }, { timeout: 180000 });
  return data;
};

export const generateRoadmap = async (reclassified, ratios, correctives = null, sector = "generico", lang = "it") => {
  const { data } = await apiClient.post("/roadmap", { reclassified, ratios, correctives, sector, lang }, { timeout: 180000 });
  return data;
};

export const getConfig = async () => {
  const { data } = await apiClient.get("/config");
  return data; // { payment_gate_enabled: bool, beta_mode: bool, brand: string }
};

// -------- Payments --------

export const createCheckout = async ({ origin_url, customer_email = null, lookup_key = "premium_report_99eur" }) => {
  const { data } = await apiClient.post("/payments/checkout", { origin_url, customer_email, lookup_key });
  return data; // { checkout_url, session_id, amount, currency }
};

export const getPaymentStatus = async (session_id) => {
  const { data } = await apiClient.get(`/payments/status/${session_id}`);
  return data; // { session_id, status, payment_status, amount_total, currency }
};

// Paid export — passes session_id header so backend gates access
export const exportFilePaid = async (kind, sessionId, reclassified, ratios, lang, cover = null, advisorText = null, correctives = null, roadmap = null) => {
  const payload = { reclassified, ratios, lang };
  if (cover) payload.cover = cover;
  if (advisorText && kind === "pdf") payload.advisor_text = advisorText;
  if (correctives && kind === "pdf") payload.correctives = correctives;
  if (roadmap && kind === "pdf") payload.roadmap = roadmap;
  const res = await apiClient.post(`/export/${kind}`, payload, {
    responseType: "blob",
    headers: { "X-Payment-Session-Id": sessionId },
  });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `bilancio_riclassificato.${kind === "excel" ? "xlsx" : "pdf"}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
